import type { ISessionRepository } from '../repositories/ISessionRepository.js';
import type { SessionEntity } from '../entities/SessionEntity.js';

interface Deps { sessionRepository: ISessionRepository; }

export function createGetSessionByIdUseCase({ sessionRepository }: Deps) {
  return async function getSessionById(id: string): Promise<SessionEntity | null> {
    return sessionRepository.getById(id);
  };
}
